import { createV3Queries } from "@query/utils/createV3Queries";
import { insuranceCoveragesApi } from "@api";

/**
 * Insurance-coverage registry — mirrors `InsuranceCoveragesApi` 1:1
 * (`/v3/compliance/insurance-coverages`, read-only — coverages are produced
 * by insurance imports and verified server-side).
 */
export const queriesInsuranceCoverages = createV3Queries(
  "insuranceCoveragesApi",
  insuranceCoveragesApi
);
